import { defer, LoaderFunction } from 'react-router-dom'

import { PaginatedResponse } from '@custom-types/response'
import Score from '@models/Score'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

export type SharedScoresResponse = { scores: Score[] } & PaginatedResponse

export type SharedScoresLoaderResponse = {
  sharedScores: Promise<SharedScoresResponse>
  order: string | null
}

export const SHARED_SCORES_PAGE_SIZE = 15

const sharedScoresLoader: LoaderFunction = async ({ request }) => {
  const url = new URL(request.url)

  const order = url.searchParams.get('order')
  const sharedScores = http.loader.post(ApiRoutes.members.sharedScoresPath(), {
    order,
    max_count: SHARED_SCORES_PAGE_SIZE,
  })
  return defer({ sharedScores, order })
}

export default sharedScoresLoader
